import { useEffect, useMemo } from "react";
import { useAppSelector } from "../store";

const CHATBOT_BASE_URL = "https://venturepact10291.chatbotbuilder.net";
const CHATBOT_APP_ID = process.env.REACT_APP_CHATBOT_APP_ID || null;
const CHATBOT_SCRIPT_ID = "rb-chatbot-script";

const RBChatbot = () => {
  const { user } = useAppSelector((state) => state.auth);
  const role = user?.role;
  const shouldLoad = (role === "admin" || role === "super_admin" || !role) && CHATBOT_APP_ID;

  const userData = useMemo(() => {
    if (user) {
      const name = user.firstName
        ? `${user.firstName} ${user.lastName || ""}`.trim()
        : "";
      return {
        email: user.email || "",
        name,
        phone: user.phone || "",
      };
    }

    const keys = ["rb_user_email", "rb_user_name", "rb_user_phone"];
    const [email, name, phone] = keys.map((k) => localStorage.getItem(k) || "");
    return { email, name, phone };
  }, [user]);

  useEffect(() => {
    if (!shouldLoad) {
      const removeChatbotNodes = () => {
        const existingScript = document.getElementById(CHATBOT_SCRIPT_ID);
        if (existingScript) {
          existingScript.remove();
        }

        document
          .querySelectorAll(`iframe[src*="${CHATBOT_BASE_URL}"]`)
          .forEach((node) => node.remove());

        document
          .querySelectorAll(
            '[id^="cbb"],[class*="cbb"],[class*="chatbotbuilder"],[data-cbb]'
          )
          .forEach((node) => node.remove());
      };

      removeChatbotNodes();
      setTimeout(removeChatbotNodes, 0);
      setTimeout(removeChatbotNodes, 300);

      window.ChatbotBuilder = undefined as unknown as typeof window.ChatbotBuilder;
      window.cbbSettings = undefined as unknown as typeof window.cbbSettings;
      return;
    }

    window.cbbSettings = {
      base_url: CHATBOT_BASE_URL,
      app_id: CHATBOT_APP_ID,
      app_type: "chat",
    };

    if (userData.email || userData.name || userData.phone) {
      window.cbbSettings.user_data = userData;
    }

    const existingScript = document.getElementById(CHATBOT_SCRIPT_ID);
    if (!existingScript) {
      const script = document.createElement("script");
      script.id = CHATBOT_SCRIPT_ID;
      script.src = `${CHATBOT_BASE_URL}/embed.js`;
      script.defer = true;
      document.body.appendChild(script);
    } else if (window.ChatbotBuilder && window.ChatbotBuilder.setUserData) {
      window.ChatbotBuilder.setUserData(userData);
    }
  }, [shouldLoad, userData]);

  return null;
};

export default RBChatbot;
